import { objectLessAttributes } from "@aws-amplify/core"

const initialUserState = {
    user: {},
    userData: {},
    loggedIn: false,
    userRefresh: false,
    userFirstRun: true,
    userDataLoaded: false,
    userAmountWithdrawn: 0,
    userWithdrawnLoaded: false,
    linkingMode: false,
    linkingData: {}
}

const userReducer = (state = initialUserState, action) => {
    switch (action.type) {
        case 'USER_LOGIN':
            return Object.assign({}, state, {
                user: action.user,
                loggedIn: true
            })
        case 'USER_LOGOUT':
            return Object.assign({}, state, {
                // user: null,
                loggedIn: false,
                user: {},
                userData: {},
                userFirstRun: true,
                userDataLoaded: false,
                userAmountWithdrawn: 0
            })
        case 'USER_DATA':
            return Object.assign({}, state, {
                userData: action.user,
                loggedIn: true,
                userRefresh: false,
                userFirstRun: false,
                userDataLoaded: true
            })
        case 'USER_FORCE_REFRESH':
            return Object.assign({}, state, {
                userRefresh: true
            })
        case 'USER_UNSET_FIRSTRUN':
            return Object.assign({}, state, {
                userFirstRun: false
            })
        case 'USER_SET_FIRSTRUN':
            return Object.assign({}, state, {
                userFirstRun: true
            })
        case 'USER_WITHDRAWN_AMOUNT':
            return Object.assign({}, state, {
                userAmountWithdrawn: action.amount,
                userWithdrawnLoaded: true
            })
        case 'START_LINKING_MODE':
            return Object.assign({}, state, {
                linkingMode: true,
                linkingData: action.data
            })
        case 'END_LINKING_MODE':
            return Object.assign({}, state, {
                linkingMode: false,
                linkingData: {}
            })
        default:
            return state
    }
}
export default userReducer;